<template>
  <div>
    <!-- :value="currentGroup.title" -->
    <div class="showBar">
      <el-button type="primary" size="mini" @click="showGroupDialog"
        >选择分组</el-button
      >
      &ensp;
      <el-tag
        :key="tag.id"
        v-for="tag in groupChoosen"
        @close="deleteChosenGroup(tag)"
        closable
        size="small"
      >
        <!-- this.$refs.studentGroupSelectTree.setCheckedKeys([4, 5]); -->

        {{ tag.title }}
      </el-tag>
    </div>

    <el-dialog
      title="选择分组"
      :visible.sync="treeChooseShow"
      width="60%"
      :append-to-body="true"
    >
      <mytree
        ref="selectTree"
        :treeData="groupTree"
        :groupChosenIds="groupChosenIds"
        @eventUp="treeEvent"
        :checkOnClickNode="checkOnClickNode"
        :expandOnClickNode="expandOnClickNode"
        :showCheckbox="showCheckbox"
        :checkStrictly="checkStrictly"
      ></mytree>
      <div slot="footer">
        <el-button type="primary" @click.stop="groupChosenConfirm"
          >确认</el-button
        >
        <el-button type="primary" plain @click="treeChooseShow = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mytree from "@/component/tree/mytree.vue";

export default {
  props: {
    groupTree: Array,
    currentGroup: {
      type: Object,
      default: () => {
        return { title: "无分类" };
      },
    },
    groupChosenIds: Array,
    currentNodeId: {
      type: Number,
      default: 0,
    },
    showCheckbox: { type: Boolean, default: false },
    checkOnClickNode: { type: Boolean, default: false },
    expandOnClickNode: { type: Boolean, default: true },
    checkStrictly: { type: Boolean, default: false },
  },
  components: { mytree },
  data() {
    return {
      treeChooseShow: false,
    };
  },
  watch: {
    currentGroup: {
      handler(...a) {
        console.log(a);
      },
      deep: true,
    },
  },
  computed: {
    currentNode() {
      let returnItem = null;
      let that = this;
      this.groupTree.forEach(function treeMaker(item) {
        if (item.id == that.currentNodeId) {
          returnItem = item;
        }
        if (item.children && item.children.length > 0) {
          item.children.forEach((nextItem) => treeMaker(nextItem));
        }
      });
      return returnItem || { title: "无分类" };
    },
    groupChoosen() {
      let choosenGroups = [];
      let that = this;
      this.groupTree.forEach(function nodeFind(node) {
        if (node.children && node.children.length > 0) {
          node.children.forEach(nodeFind);
        }
        if (that.groupChosenIds.includes(node.id)) {
          choosenGroups.push(node);
        }
      });
      return choosenGroups;
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      console.log(this.currentGroup);
    }, 2000);
  },
  methods: {
    groupChosenConfirm() {
      console.log("111111");
      this.$refs.selectTree.getChosenKeys();

      this.treeChooseShow = false;
    },
    deleteChosenGroup(tag) {
      this.groupChosenIds.splice(this.groupChosenIds.indexOf(tag.id), 1);
      this.$refs.selectTree.setCheckedKeys(this.groupChosenIds);
    },
    treeEvent(...data) {
      this.$emit("eventUp", ...data);
    },
    showGroupDialog() {
      this.treeChooseShow = true;
    },
    setCheckedKeys(keys) {
      console.log(this.$refs);
      this.$refs.selectTree.setCheckedKeys(keys);
    },
  },
};
</script>

<style scoped lang="less">
.showBar {
  padding: 5px 0 5px 5px;
  line-height: 32px;
  border: 1px solid #36aafd;
  border-radius: 5px;
  width: 80%;
  .el-button--small,
  .el-tag {
    margin-right: 10px;
  }
}
</style>
